import axios from "axios";
import { refreshToken } from "../helpers/RequestExecutor";

export const hostGame = async () => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/games/create`, {}, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        });
        return response.data;
    } catch (e) {
        if (e.status === 401) {
            await refreshToken();
            return await hostGame();
        } else {
            return {};
        }
    }
}

export const joinGame = async (gameId) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/players/add`, {
            gameId
        }, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        });
        return response.data;
    } catch (e) {
        if (e.status === 401) {
            await refreshToken();
            return await joinGame(gameId);
        } else {
            return e.response.data;
        }
    }
}

export const cancelGame = async () => {
    try {
        const response = await axios.delete(`${process.env.REACT_APP_SERVER_URL}/games`, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        });
        return response.data;
    } catch (e) {
        if (e.status === 401) {
            await refreshToken();
            return await cancelGame();
        } else {
            return e.response.data;
        }
    }
}


export const startGame = async () => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/game/start`, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        });
        return response.data;
    } catch (e) {
        if (e.status === 401) {
            await refreshToken();
            return await startGame();
        } else {
            return e.response.data;
        }
    }
}

export const endGame = async () => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/game/end`, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        });
        return response.data;
    }
    catch (e) {
        if (e.status === 401) {
            await refreshToken();
            return await endGame();
        } else {
            return e.response.data;
        }
    }
}

export const exitGame = async () => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/game/exit`, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        });
        return response.data;
    }
    catch (e) {
        if (e.status === 401) {
            await refreshToken();
            return await exitGame();
        } else {
            return e.response.data;
        }
    }
}

export const getFinalResults = async () => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/game/final-results`, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        });
        return response.data;
    }
    catch (e) {
        if (e.status === 401) {
            await refreshToken();
            return await getFinalResults();
        } else {
            return e.response.data;
        }
    }
}

export const getGoLiveDetails = async () => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/are-we-live`);
        return response.data;
    } catch (e) {
        return e.response.data;
    }
}